import * as Combobox from '@givebutter/primitives/combobox';
import { LoadingOverlay } from '@givebutter/primitives/loading-overlay';
import * as TaskAssignee from 'components/tasks/TaskAssignee';
import { CrmMember } from 'types/domain';

interface AssigneeComboboxItemsProps {
    members: CrmMember[];
    isLoading?: boolean;
}
const AssigneeComboboxItems = ({ members, isLoading = false }: AssigneeComboboxItemsProps) => {
    return (
        <Combobox.Items>
            <LoadingOverlay isLoading={isLoading}>
                <Combobox.Item value="no_assignee">
                    <Combobox.ItemText>
                        <TaskAssignee.Content assignee={null} />
                    </Combobox.ItemText>
                    <Combobox.CheckmarkIndicator />
                </Combobox.Item>
                {members.map(member => (
                    <Combobox.Item value={member.id.toString()} key={member.id}>
                        <Combobox.ItemText>
                            <TaskAssignee.Content assignee={member} />
                        </Combobox.ItemText>
                        <Combobox.CheckmarkIndicator />
                    </Combobox.Item>
                ))}
                {members.length === 0 && (
                    <Combobox.NoneFoundText>No assignees found</Combobox.NoneFoundText>
                )}
            </LoadingOverlay>
        </Combobox.Items>
    );
};

export { AssigneeComboboxItems };
